import React, { useEffect, useState } from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";
import ArabicRegular from "../../../../../../../../src/assets/ArabicFont/IBMPlexSansArabic-Regular.ttf";
import ArabicBold from "../../../../../../../../src/assets/ArabicFont/IBMPlexSansArabic-Bold.ttf";
import PageLayout from "./PageLayout";
import ArabicComponent from "../../../../../../../utils/ArabComponent/ArabicComponent";
import LastPage from "./LastPage";

export default function EmployeeContract({ contractDetails, data, company }) {
  Font.register({
    family: "Arabic",
    src: ArabicRegular,
  });
  Font.register({
    family: "ArabicBold",
    src: ArabicBold,
  });

  const [companyDetails, setCompanyDetails] = useState({});

  useEffect(() => {
    const filteredCompany = company?.filter(
      (item, index) => data?.company_id == item?.id
    );
    setCompanyDetails(filteredCompany);
  }, []);

  // Create a new Date object
  var currentDate = new Date();

  // Get the current year, month, and day
  var year = currentDate.getFullYear();
  var month = currentDate.getMonth() + 1; // Note: Months are zero-based
  var day = currentDate.getDate();

  const downloadDate = `${day}/${month}/${year}`;
  const regex = /\d+/;
  let allTotal = 0;

  let propertiesToCheck = [
    "basic",
    "food",
    "fixed_ot",
    "hra",
    "travel_allowance",
    "mobile_allowance",
    "air_ticket_allowance",
    "additional_ot",
    "other_allowance",
  ];

  propertiesToCheck.forEach((property) => {
    // Check if the value is a number using regex
    if (regex.test(data[property])) {
      // Convert the matched value to a number and add it to the total
      allTotal += parseInt(data[property], 10);
    }
  });

  const termsData = {
    english: [
      {
        id: "1.1",
        text: `Job Tiltle: ${data?.job_position_name}`,
      },
      {
        id: "1.2",
        text: `Contract Duration: ${data?.duration_of_contract}`,
      },
      {
        id: "1.3",
        text: `Contract starting Date: ${data?.arrival_date}`,
      },
      {
        id: "1.4",
        text: `Probation Period: ${data?.probation_period}`,
      },
      {
        id: "2",
        text: `The second party will work for the first party in his main office or one of its branches or any place belonging to the first party inside K.S.A as per the contract terms in position of (1.1), the second party will oblige to do his duties and responsibilities as required by the first party.`,
      },
      {
        id: "3",
        text: `Duty hours will be ${data?.duty_hours} hours including prayer break hours per day (6 days per week).  Friday will be the official weekly rest day.  Excluded from this clause, will be some departments that are required to work on Fridays in which case another day of the week will be a rest day.         Fixed OT hours will be ${data?.fixed_ot_hours} Hours per day (6 days per week).  The compensation for the fixed OT hours will be paid by the first party as per the clause mentioned below in 7.3 `,
      },
      {
        id: "4",
        text: `The working hours may be changed from time to time to suit specific work site conditions. Furthermore, the second party is expected to work the hours necessary to fulfil his duties and remuneration for additional hours will be paid as per the KSA Labor law.`,
      },
      {
        id: "5",
        text: `The contract will automatically renew for other periods as stated in item (1.2) of this contract- with the same terms and privileges –unless one of the two parties informed the other, he do not like to renew the contract prior 2 months of the expiration of the current contract, with consideration to the items Nos (37&55) of Saudi labor law.`,
      },
      {
        id: "6",
        text: ``,
        points: [
          "Leave entitlement (21) calendar days per annum.",
          "Eligibility after completion of contract tenure as stated in above clause 1.2",
          "Eligibility for Return Air Ticket to country of origin as per below stated clause 7.7",
        ],
      },
    ],
    arabic: [
      {
        id: "1.1",
        text: `المسمى الوظيفي :${data?.job_position_name}`,
      },
      {
        id: "1.2",
        text: `فترة العقد: : ${data?.duration_of_contract}`,
      },
      {
        id: "1.3",
        text: `بداية العقد : ${data?.arrival_date}`,
      },
      {
        id: "1.4",
        text: `فترة التجربة : ${data?.probation_period}`,
      },
      {
        id: "2",
        text: `سيعمل الطرف الثاني لدى الطرف الأول في المكنب الرئيسي أو أحد الفروع أو أي مكان تابع للطرف الأول داخل بالمملكة العربية السعودية  وفق بند العقد  (١٫١) على أن يلتزم الطرف الثاني بأداء واجباته  ومسئولياته وكل ما يتعلق بوظيفته وما يكلفه به الطرف الأول  .`,
      },
      {
        id: "3",
        text: `${data?.duty_hours} ساعات العمل  ستكون 
ساعة متضمنة وقت الصلوات في اليوم،  ( 6 ايام في الاسبوع) .  وسيكون يوم الجمعة هو يوم الراحة  الاسبوعي الرسمي .هنالك بعض الاقسام يطلب منها  الحضور يوم الجمعة وفي هذ الحالة يكون يوم اخر من ايام الاسبوع يوم راحة.
${data?.fixed_ot_hours} ساعات العمل الثابتة
 ساعة في اليوم (6 أيام في الاسبوع) . بالنسبة للتعويض عن ساعات العمل الإضافية الثابتة سيتم دفعه من قبل الطرف الأول كما تم ذكره في المادة 7.3`,
      },
      {
        id: "4",
        text: `قد تتغير ساعات العمل من وقت لأخر حسب متطلبات العمل لتتناسب مع ظروف مواقع الاعمال المحددة . وعلاوة على ذلك من المتوقع أن يعمل الطرف الثاني الساعات اللازمة للقيام بواجباته وسيتم إحتساب أجر الساعات الإضافية وفقاً لقانون العمل السعودي `,
      },
      {
        id: "5",
        text: `سيتم تجديد هذا العقد تلقائياً عند إلانتهاء لفترة اخرى  مماثلة للمدة المنصوص عليها في البند (1.2)  من هذا العقد - بنفس بنود العقد و شروطه ومميزاته ما لم يقم أحد الطرفين الآخر بإشعار الطرف الاخر خطياً بعدم الرغبة في تجديد العقد قبل شهرين من تاريخ إنتهاء مدة العقد الحالي مع مراعاة البندين (37&55) من نظام العمل السعودي .`,
      },
      {
        id: "6",
        text: ``,
        points: [
          " الإجازة السنوية المستحقة  (21) يوم سنوياً .-",
          "- الأهلية والإستحقاق بعد مضي سنة من  العقد وفقاً للبند 1.2",
          "- الأهلية والإستحقاق لتذكرة طيران العودة للوطن وفقاً للبند 7.7",
        ],
      },
    ],
  };

  const salaryData = {
    english: [
      {
        id: "7.1",
        text: `Basic Salary: SAR  ${data?.basic} per month `,
      },
      {
        id: "7.2",
        text: `Food Allowance: ${data?.food}`,
      },
      {
        id: "7.3",
        text: `Fixed OT: ${data?.fixed_ot}`,
      },
      {
        id: "7.4",
        text: `HRA/Accommodation: ${data?.hra}`,
      },
      {
        id: "7.5",
        text: `Transportation/Allowance:  ${data?.travel_allowance}`,
      },
      {
        id: "7.6",
        text: `Mobile Allowance: ${data?.mobile_allowance}`,
      },
      {
        id: "7.7",
        text: `Air Ticket Allowance: ${data?.air_ticket_allowance}`,
      },
      {
        id: "7.8",
        text: `Additional OT: ${data?.additional_ot}`,
      },
      {
        id: "7.9",
        text: `Other Allowance: SAR  ${data?.other_allowance} per month`,
      },
      {
        id: "7.10",
        text: `Total Salary: SAR  ${allTotal} per month`,
      },
      {
        id: "8",
        text: `The second party should pay the full expenses issued for him/her by the first party such as Iqama, visa, joining ticket, recruiting office fees, transport, training, labor office fees, post arrival medical checkup, insurance and any damage to tangible/intangible assets of the first party in case the contract is breached / not completed / escaped as per the agreed period stated above in clause 1.2`,
      },
      {
        id: "9",
        text: `Anything not mentioned in this contract shall be according to the Saudi Labor Laws.`,
      },
      {
        id: "10",
        text: `The second party has no right to work either direct or in direct with or without pay in any position or service or commercial works other than assigned by the first party as per item (39) of Saudi labor law.`,
      },
      {
        id: "11",
        text: `The Gregorian date will be followed and approved in all scenarios.`,
      },
      {
        id: "12",
        text: `The second party agreed that he/she reviewed and understood all the contract items and contents and has no right to criticize the contract contents or anything else, also the second party has agreed that, he/she will abide to the work assigned by the first party and well aware of all its conditions, items and contents.`,
      },
      {
        id: "13",
        text: `This contract will be valid after signature and stamp by the first party and signed by the second party`,
      },
      {
        id: "14",
        text: `This contract is issued into two copies; each party received one copy to work accordingly.`,
      },
    ],
    arabic: [
      {
        id: "7.1",
        text: ` ${data?.basic} الراتب الأساسي:   شهرياَ `,
      },
      {
        id: "7.2",
        text: `بدل الطعام :
${data?.food}`,
      },
      {
        id: "7.3",
        text: `${`الساعات الثابتة : ${data?.fixed_ot}`}`,
      },
      {
        id: "7.4",
        text: `بدل السكن: ${data?.hra}`,
      },
      {
        id: "7.5",
        text: `بدل / النقل: ${data?.travel_allowance}`,
      },
      {
        id: "7.6",
        text: `بدل موبايل: ${data?.mobile_allowance}`,
      },
      {
        id: "7.7",
        text: `بدل تذاكر طيران : ${data?.air_ticket_allowance}`,
      },
      {
        id: "7.8",
        text: `بدل وقت إضافي : ${data?.additional_ot}`,
      },
      {
        id: "7.9",
        text: `بدلات أخرى : ريال ${data?.other_allowance}`,
      },
      {
        id: "7.10",
        text: `ريال شهرياً ${allTotal} إجمالي الراتب :`,
      },
      {
        id: "8",
        text: `يجب على الطرف الثاني أن يدفع كامل النفقات المدفوعة له/ لها من قبل الطرف الأول مثل الإقامة، التأشيرة، تذكرة السفر ، رسوم مكتب الاستقدام ، النقل ، التدريب ، رسوم مكتب العمل ، الفحص الطبي بعد الوصول والتأمين وأي أضرار مادية/ الأصول غير الملموسة للطرف الأول في حالة الإخلال بالعقد / عدم اكتماله / الهروب منه حسب المدة المتفق عليها المذكورة أعلاه في البند  1.2`,
      },
      {
        id: "9",
        text: `ي نقاط لم يرد ذكرها في هذا العقد يجب ان تخضع لقانون  وأنظمة العمل السعودي `,
      },
      {
        id: "10",
        text: `لا يحق للطرف الثاني العمل بشكل مباشر أو غير  مباشر بأجر أو بدون أجر في أي وظيفة أو خدمة أو أعمال تجارية بخلاف ما يكلفه به الطرف الأول بموجب البند (39) من نظام العمل السعودي .`,
      },
      {
        id: "11",
        text: `التقويم الميلادي سيكون هو  المتبع  والمعمول في كل السيناريوهات`,
      },
      {
        id: "12",
        text: `وافقت / وافق الطرف الثاني على أنه قام بمراجعة وفهم جميع بنود العقد ومحتوياته ولا يحق له انتقاد محتويات العقد أو أي شيء آخر، كما وافقت / وافق الطرف الثاني على الإلتزام بالعمل الذي كلفه به الطرف الأول. وانه على علم تام بجميع شروطه وبنوده ومحتوياته .`,
      },
      {
        id: "13",
        text: `يسري هذا العقد بعد التوقيع والختم عليه من قبل الطرف الاول والتوقيع عليه من قبل الطرف الثاني .`,
      },
      {
        id: "14",
        text: `تم تحرير هذا العقد من نسختين : كل طرف يحصل على نسخة واحدة للعمل بموجبها`,
      },
    ],
  };
  return (
    <Document style={{ fontSize: "12px" }}>
      <PageLayout pageNo={1} company={contractDetails?.visa_provider}>
        <View
          fixed
          style={{
            borderTop: 1,
            width: "100%",
            position: "absolute",
            top: 100,
            right: 30,
            padding: 1,
            margin: "auto",
          }}
        ></View>
        {/* title */}
        <View
          style={{
            flexDirection: "row",
            fontFamily: "Helvetica-Bold",
            marginTop: 20,
          }}
        >
          <View style={{ width: "100%" }}>
            <Text>EMPLOYMENT AGREEMENT</Text>
          </View>
          <View style={{ width: "100%" }}>
            <ArabicComponent
              arabText={"عقد عمل"}
              textStyle={{ fontFamily: "ArabicBold" }}
            />
          </View>
        </View>
        {/* date */}
        <View style={{ flexDirection: "row", width: "100%", marginTop: 3 }}>
          <View style={{ width: "100%" }}>
            <Text>Date: {downloadDate}</Text>
          </View>
          <View style={{ width: "100%", alignItems: "flex-end" }}>
            <Text style={{ textAlign: "right" }}>
              {downloadDate}
              <ArabicComponent
                arabText={"تاريخ"}
                textStyle={{ fontFamily: "ArabicBold" }}
              />
            </Text>
          </View>
        </View>
        {/* Table 1 */}
        <View
          style={{
            border: "1px solid black",
            flexDirection: "row",
            marginTop: "10px",
          }}
        >
          <View style={{ width: "100%", borderRight: 1, padding: "3px" }}>
            <Text>
              This EMPLOYMENT contract is made between{" "}
              {companyDetails[0]?.name ? companyDetails[0]?.name : ""}{" "}
              {companyDetails[0]?.address ? companyDetails[0]?.address : ""}{" "}
              {companyDetails[0]?.po_box ? companyDetails[0]?.po_box : ""}{" "}
              {companyDetails[0]?.pincode ? companyDetails[0]?.pincode : ""}{" "}
              herein after called the (EMPLOYER) FIRST PARTY and the below
              (EMPLOYEE) SECOND PARTY:
            </Text>
          </View>
          <View style={{ width: "100%", padding: "3px" }}>
            <ArabicComponent
              arabText={`هذه الإتفاقية تمت بين ${
                companyDetails[0]?.name_arabic
                  ? companyDetails[0]?.name_arabic
                  : ""
              } ${
                companyDetails[0]?.address_arabic
                  ? companyDetails[0]?.address_arabic
                  : ""
              } ${companyDetails[0]?.po_box ? companyDetails[0]?.po_box : ""} ${
                companyDetails[0]?.pincode ? companyDetails[0]?.pincode : ""
              } ممثلة في (الموظف ) الطرف الأول والمذكور (صاحب العمل ) الطرف الثاني :`}
            />
          </View>
        </View>
        {/* Table 2 */}
        <View style={{ border: 1, flexDirection: "row", marginTop: 10 }}>
          <View style={{ borderRight: 1, width: "100%" }}>
            <View style={{ padding: 3, width: "100%", borderBottom: 1 }}>
              <Text>
                Name: <Text>{data?.name}</Text>
              </Text>
            </View>
            <View style={{ padding: 3, width: "100%", borderBottom: 1 }}>
              <Text>
                Nationality: <Text>{data?.nationality_name}</Text>
              </Text>
            </View>
            <View style={{ padding: 3, width: "100%", borderBottom: 1 }}>
              <Text>
                Passport No: <Text>{data?.passport_number}</Text>
              </Text>
            </View>
            <View style={{ padding: 3, width: "100%" }}>
              <Text>
                Employee Code: <Text>{data?.candidate_id}</Text>
              </Text>
            </View>
          </View>
          <View style={{ width: "100%" }}>
            <View style={{ padding: 3, width: "100%", borderBottom: 1 }}>
              <Text style={{ textAlign: "right" }}>
                {data?.name}
                <ArabicComponent arabText={"الاسم:"} />
              </Text>
            </View>
            <View style={{ padding: 3, width: "100%", borderBottom: 1 }}>
              <Text style={{ textAlign: "right" }}>
                {data?.nationality_name}
                <ArabicComponent arabText={"الجنسية :"} />
              </Text>
            </View>
            <View style={{ padding: 3, width: "100%", borderBottom: 1 }}>
              <Text style={{ textAlign: "right" }}>
                {data?.passport_number}
                <ArabicComponent arabText={"رقم الجواز :"} />
              </Text>
            </View>
            <View style={{ padding: 3, width: "100%" }}>
              <Text style={{ textAlign: "right" }}>
                {data?.candidate_id}
                <ArabicComponent arabText={"الرقم الوظيفي :"} />
              </Text>
            </View>
          </View>
        </View>
        {/* Table 3 terms */}
        <View
          style={{
            flexDirection: "row",
            border: 1,
            marginTop: 10,
            borderBottom: 0,
            fontFamily: "Helvetica-Bold",
          }}
        >
          <View style={{ width: "100%", borderRight: "1px", padding: 3 }}>
            <Text>Terms & Conditions of Employment:</Text>
          </View>
          <View style={{ width: "100%", padding: 3 }}>
            <ArabicComponent
              arabText={"حيث اتفق الطرفان على جميع الشروط ما يلي :"}
            />
          </View>
        </View>
        <View style={{ border: 1, flexDirection: "row" }}>
          {/* english */}
          <View style={{ width: "100%", borderRight: "1px" }}>
            {termsData.english.map((item, index) => (
              <View
                style={{
                  width: "100%",
                  flexDirection: "row",
                  borderBottom: index == 8 ? 0 : 1,
                }}
                key={index}
              >
                <View
                  style={{
                    width: "15%",
                    padding: "3px",
                    borderRight: 1,
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Text>{item.id}</Text>
                </View>
                <View
                  style={{
                    width: "85%",
                    padding: "3px",
                    height:
                      index >= 4 && index <= 7 && index !== 5
                        ? 100
                        : index == 5
                          ? 130
                          : "",
                  }}
                >
                  <Text>{item.text}</Text>
                  {item?.points?.map((point, index) => (
                    <Text key={index}>
                      <Text
                        style={{ fontFamily: "Helvetica-Bold", margin: 2 }}
                      >{`>`}</Text>
                      {point}
                    </Text>
                  ))}
                </View>
              </View>
            ))}
          </View>
          {/* arabic */}
          <View style={{ width: "100%" }}>
            {termsData.arabic.map((item, index) => (
              <View
                style={{
                  width: "100%",
                  flexDirection: "row",
                  borderBottom: index == 8 ? 0 : 1,
                }}
                key={index}
              >
                <View
                  style={{
                    width: "85%",
                    padding: "3px",
                    paddingTop: index == 7 ? 20 : "",
                    paddingBottom: index == 7 ? 5 : "",
                    height:
                      index >= 4 && index <= 7 && index !== 5
                        ? 100
                        : index == 5
                          ? 130
                          : index == 8
                            ? 60
                            : "",
                  }}
                >
                  <ArabicComponent arabText={item?.text} />
                  {item?.points?.map((point, index) => (
                    <Text key={index}>
                      <Text
                        style={{ fontFamily: "Helvetica-Bold", margin: 2 }}
                      >{`>`}</Text>
                      <ArabicComponent arabText={point} />
                    </Text>
                  ))}
                </View>
                <View
                  style={{
                    width: "15%",
                    padding: "3px",
                    borderLeft: 1,
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Text>{item.id}</Text>
                </View>
              </View>
            ))}
          </View>
        </View>

        {/* table 4   salary */}
        <View
          style={{
            flexDirection: "row",
            border: 1,
            marginTop: 10,
            borderBottom: 0,
            fontFamily: "Helvetica-Bold",
          }}
        >
          <View style={{ width: "100%", borderRight: "1px", padding: 3 }}>
            <Text>Salary & allowances</Text>
          </View>
          <View style={{ width: "100%", padding: 3 }}>
            <ArabicComponent arabText={"الراتب والبدلات"} />
          </View>
        </View>
        <View style={{ border: 1, flexDirection: "row" }}>
          {/* english */}
          <View style={{ width: "100%", borderRight: "1px" }}>
            {salaryData.english.map((item, index) => (
              <View
                style={{
                  width: "100%",
                  flexDirection: "row",
                  borderBottom: index == 16 ? 0 : 1,
                }}
                key={index}
              >
                <View
                  style={{
                    width: "15%",
                    padding: "3px",
                    borderRight: 1,
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Text>{item.id}</Text>
                </View>
                <View
                  style={{
                    width: "85%",
                    padding: "3px",
                    height: index >= 10 ? 100 : 40,
                  }}
                >
                  <Text>{item.text}</Text>
                  {item?.points?.map((point, index) => (
                    <Text key={index}>
                      <Text
                        style={{ fontFamily: "Helvetica-Bold", margin: 2 }}
                      >{`>`}</Text>
                      {point}
                    </Text>
                  ))}
                </View>
              </View>
            ))}
          </View>
          {/* arabic */}
          <View style={{ width: "100%" }}>
            {salaryData.arabic.map((item, index) => (
              <View
                style={{
                  width: "100%",
                  flexDirection: "row",
                  paddingTop: index == 16 ? 33 : "",
                  borderBottom: index == 16 ? 0 : 1,
                }}
                key={index}
              >
                <View
                  style={{
                    width: "85%",
                    padding: "3px",
                    paddingTop: index == 10 ? 30 : "",
                    height: index >= 11 ? 100 : index == 10 ? 135 : 40,
                  }}
                >
                  <ArabicComponent arabText={item?.text} />
                  {item?.points?.map((point, index) => (
                    <Text key={index}>
                      <Text
                        style={{ fontFamily: "Helvetica-Bold", margin: 2 }}
                      >{`>`}</Text>
                      <ArabicComponent arabText={point} />
                    </Text>
                  ))}
                </View>
                <View
                  style={{
                    width: "15%",
                    padding: "3px",
                    borderLeft: 1,
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Text>{item.id}</Text>
                </View>
              </View>
            ))}
          </View>
        </View>
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <View
            style={{
              flexDirection: "column",
              justifyContent: "space-between",
              marginTop: 10,
            }}
          >
            <Text style={{ marginBottom: 20 }}>Yours Sincerely,</Text>

            <Text>
              {" "}
              <Text style={{ fontFamily: "Helvetica-Bold" }}>
                {" "}
                NAME:
              </Text>{" "}
              Okap Mufadi G. Al-Enizy
            </Text>

            <Text style={{ marginTop: 10}}>
              {" "}
              <Text style={{ fontFamily: "Helvetica-Bold" }}>
                {" "}
                Designation:
              </Text>{" "}
              Managing Director
            </Text>
            <Text style={{ marginTop: 10 }}>
              {" "}
              <Text style={{ fontFamily: "Helvetica-Bold" }}>
                {" "}
                Sponsor:
              </Text>{" "}
              Business experience Co ltd.
            </Text>
          </View>
          <View style={{ marginTop: 10 }}>
            <Text style={{ marginBottom: 20 }}>
              Signature <ArabicComponent arabText={"التوقيع"} />
            </Text>
            <Text style={{ marginBottom: 10 }}>
              Name <ArabicComponent arabText={"الأسم"} />
            </Text>
            <Text style={{ marginBottom: 10 }}>
              Passport Number: <ArabicComponent arabText={"رقم الجواز"} />
            </Text>
            <Text style={{ marginBottom: 10 }}>
              Thumb Impression / <ArabicComponent arabText={"البصمة"} />
            </Text>
          </View>
        </View>
        {/* table 5 details */}
        <View
          style={{
            fontFamily: "Helvetica-Bold",
            marginTop: 20,
            justifyContent: "center",
          }}
          break
        >
          <Text
            style={{
              textAlign: "center",
              marginBottom: 5,
              textDecoration: "underline",
            }}
          >
            TO WHOMSOEVER IT MAY CONCERN
          </Text>
          <Text style={{ textAlign: "center", marginBottom: 5 }}>
            <ArabicComponent arabText={"إلى من يهمه الأمر"} />
          </Text>
          <Text
            style={{
              textAlign: "center",
              marginBottom: 5,
            }}
          >
            UNDERTAKING DECLARATION
          </Text>
          <Text style={{ textAlign: "center", marginBottom: 5 }}>
            <ArabicComponent arabText={"إعلان تعهد"} />
          </Text>
        </View>

        {/* table 5 */}
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Text>Date: {data?.arrival_date}</Text>
          <ArabicComponent arabText={`${data?.arrival_date}  التاريخ:`} />
        </View>

        <View style={{ border: 1, flexDirection: "row", marginTop: 10 }}>
          <View style={{ width: "100%", borderRight: 1, padding: 3 }}>
            <Text>
              I, {data?.name} bearing {data?.nationality_name} Passport Number{" "}
              {data?.passport_number}
              hereby confirm my employment as {
                data?.job_position_name
              } with {companyDetails[0]?.name} on the below Terms & Conditions:
            </Text>
          </View>
          <View style={{ width: "100%", padding: 3 }}>
            <ArabicComponent
              arabText={` ${data?.nationality_name} ${data?.name} انا ${data?.passport_number} احمل جواز سفر  ${data?.job_position_name} اوافق علالعملك${companyDetails[0]?.name_arabic}  معوفقاً للشروط والأحكام التالية :`}
            />
          </View>
        </View>
        {/* row 1 */}
        <View style={{ flexDirection: "row", border: 1, borderTop: 0 }}>
          {/* col 1 */}
          <View
            style={{
              width: "12.5%",
              borderRight: 1,
              padding: 3,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Text>1</Text>
          </View>
          {/* col 2 */}
          <View
            style={{
              width: "25%",
              borderRight: 1,
              padding: 3,
            }}
          >
            <Text>Contract Starting from</Text>
          </View>
          {/* col 3 */}
          <View
            style={{
              width: "25%",
              borderRight: 1,
              padding: 3,
            }}
          >
            <Text>{data?.arrival_date}</Text>
          </View>
          {/* col 4 */}
          <View
            style={{
              width: "25%",
              borderRight: 1,
              padding: 3,
            }}
          >
            <ArabicComponent arabText={`بداية العقد`} />
          </View>
          {/* col 5 */}
          <View
            style={{
              width: "12.5%",
              padding: 3,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Text>1</Text>
          </View>
        </View>
        {/* row 2 */}
        <View style={{ flexDirection: "row", border: 1, borderTop: 0 }}>
          {/* col 1 */}
          <View
            style={{
              width: "12.5%",
              borderRight: 1,
              padding: 3,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Text>2</Text>
          </View>
          {/* col 2 */}
          <View
            style={{
              width: "25%",
              borderRight: 1,
              padding: 3,
            }}
          >
            <Text>Contract for (period)</Text>
          </View>
          {/* col 3 */}
          <View
            style={{
              width: "25%",
              borderRight: 1,
              padding: 3,
            }}
          >
            <Text>{data?.duration_of_contract}</Text>
          </View>
          {/* col 4 */}
          <View
            style={{
              width: "25%",
              borderRight: 1,
              padding: 3,
            }}
          >
            <ArabicComponent arabText={`مدة العقد`} />
          </View>
          {/* col 5 */}
          <View
            style={{
              width: "12.5%",
              padding: 3,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Text>2</Text>
          </View>
        </View>
        {/* row 3 */}
        <View style={{ flexDirection: "row", border: 1, borderTop: 0 }}>
          {/* col 1 */}
          <View
            style={{
              width: "12.5%",
              borderRight: 1,
              padding: 3,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Text>3</Text>
          </View>
          {/* col 2 */}
          <View
            style={{
              width: "25%",
              borderRight: 1,
              padding: 3,
            }}
          >
            <Text>Work Location</Text>
          </View>
          {/* col 3 */}
          <View
            style={{
              width: "25%",
              borderRight: 1,
              padding: 3,
            }}
          >
            <Text>{`Anywhere in Kingdom of Saudi Arabia`}</Text>
          </View>
          {/* col 4 */}
          <View
            style={{
              width: "25%",
              borderRight: 1,
              padding: 3,
            }}
          >
            <ArabicComponent arabText={`مكان العمل `} />
          </View>
          {/* col 5 */}
          <View
            style={{
              width: "12.5%",
              padding: 3,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Text>3</Text>
          </View>
        </View>
        {/* row 4 */}
        <View style={{ flexDirection: 'row', borderWidth: 1, borderTopWidth: 0 }}>
      {/* col 1 */}
      <View
        style={{
          // flex: 1,
          width: "12.5%",
          borderRightWidth: 1,
          padding: 2,
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Text>4</Text>
      </View>

      {/* col 2 */}
      <View
        style={{
          flex: 2,
          width: "12.5%",
          borderRightWidth: 1,
          padding: 3,
        }}
      >
        <Text>Salary Details</Text>
        <View style={{ width: '105%', height: 1, backgroundColor: '#000', marginVertical: 5, alignSelf: 'flex-start', marginLeft: -3 }} />
        <Text>a) Basic Salary:</Text>
        <View style={{ width: '105%', height: 1, backgroundColor: '#000', marginVertical: 5, alignSelf: 'flex-start', marginLeft: -3 }} />
        <Text>b) Food Allowance:</Text>
        <View style={{ width: '105%', height: 1, backgroundColor: '#000', marginVertical: 5, alignSelf: 'flex-start', marginLeft: -3 }} />
        <Text>c) Fixed OT:</Text>
        <View style={{ width: '105%', height: 1, backgroundColor: '#000', marginVertical: 5, alignSelf: 'flex-start', marginLeft: -3 }} />
        <Text>d) HRA/Accommodation:</Text>
        <View style={{ width: '105%', height: 1, backgroundColor: '#000', marginVertical: 5, alignSelf: 'flex-start', marginLeft: -3 }} />
        <Text>e) Transportation/Allowance: </Text>
        <View style={{ width: '105%', height: 1, backgroundColor: '#000', marginVertical: 5, alignSelf: 'flex-start', marginLeft: -3 }} />
        <Text>f) Mobile Allowance: </Text>
        <View style={{ width: '105%', height: 1, backgroundColor: '#000', marginVertical: 5, alignSelf: 'flex-start', marginLeft: -3 }} />
        <Text>g) Air Ticket Allowance: </Text>
        <View style={{ width: '105%', height: 1, backgroundColor: '#000', marginVertical: 5, alignSelf: 'flex-start', marginLeft: -3 }} />
        <Text>h) Additional OT: </Text>
        <View style={{ width: '105%', height: 1, backgroundColor: '#000', marginVertical: 5, alignSelf: 'flex-start', marginLeft: -3 }} />
        <Text>i) Other Allowance: </Text>
        <View style={{ width: '105%', height: 1, backgroundColor: '#000', marginVertical: 5, alignSelf: 'flex-start', marginLeft: -3 }} />
        <Text>j) Total Salary: </Text>
      </View>

      {/* col 3 */}
      <View
        style={{
          flex: 2,
          width: "12.5%",
          borderRightWidth: 1,
          padding: 3,
        }}
      >
        <Text>{'Amount'}</Text>
        <View style={{ width: '105%', height: 1, backgroundColor: '#000', marginVertical: 5, alignSelf: 'flex-start', marginLeft: -3 }} />
        <Text>{`SAR  ${data?.basic} per month`}</Text>
        <View style={{ width: '105%', height: 1, backgroundColor: '#000', marginVertical: 5, alignSelf: 'flex-start', marginLeft: -3 }} />
        <Text>{data?.food}</Text>
        <View style={{ width: '105%', height: 1, backgroundColor: '#000', marginVertical: 5, alignSelf: 'flex-start', marginLeft: -3 }} />
        <Text>{data?.fixed_ot}</Text>
        <View style={{ width: '105%', height: 1, backgroundColor: '#000', marginVertical: 5, alignSelf: 'flex-start', marginLeft: -3 }} />
        <Text>{data?.hra}</Text>
        <View style={{ width: '105%', height: 1, backgroundColor: '#000', marginVertical: 5, alignSelf: 'flex-start', marginLeft: -3 }} />
        <Text>{data?.travel_allowance}</Text>
        <View style={{ width: '105%', height: 1, backgroundColor: '#000', marginVertical: 5, alignSelf: 'flex-start', marginLeft: -3 }} />
        <Text>{data?.mobile_allowance}</Text>
        <View style={{ width: '105%', height: 1, backgroundColor: '#000', marginVertical: 5, alignSelf: 'flex-start', marginLeft: -3 }} />
        <Text>{data?.air_ticket_allowance}</Text>
        {/* <View style={{ width: '105%', height: 1, backgroundColor: '#000', marginVertical: 5, alignSelf: 'flex-start', marginLeft: -3 }} />
        <Text>{data?.ticket}</Text> */}
        <View style={{ width: '105%', height: 1, backgroundColor: '#000', marginVertical: 5, alignSelf: 'flex-start', marginLeft: -3 }} />
        <Text>{data?.additional_ot ? data?.additional_ot : 0}</Text>
        <View style={{ width: '105%', height: 1, backgroundColor: '#000', marginVertical: 5, alignSelf: 'flex-start', marginLeft: -3 }} />
        <Text>{data?.other ? data?.other : 0}</Text>
        <View style={{ width: '105%', height: 1, backgroundColor: '#000', marginVertical: 5, alignSelf: 'flex-start', marginLeft: -3 }} />
        <Text>{allTotal}</Text>
      </View>

      {/* col 4 */}
      <View
        style={{
          flex: 2,
          width: "12.5%",
          borderRightWidth: 1,
          padding: 3,
        }}
      >
        <ArabicComponent arabText={'تفاصيل الراتب'} />
        <View style={{ width: '105%', height: 1, backgroundColor: '#000', marginVertical: 5, alignSelf: 'flex-start', marginLeft: -3 }} />
        <ArabicComponent arabText={'أ) الراتب الأساسي'} />
        <View style={{ width: '105%', height: 1, backgroundColor: '#000', marginVertical: 5, alignSelf: 'flex-start', marginLeft: -3 }} />
        <ArabicComponent arabText={'ب) بدل الطعام'} />
        <View style={{ width: '105%', height: 1, backgroundColor: '#000', marginVertical: 5, alignSelf: 'flex-start', marginLeft: -3 }} />
        <ArabicComponent arabText={'ت) بدل وقت إضافي'} />
        <View style={{ width: '105%', height: 1, backgroundColor: '#000', marginVertical: 5, alignSelf: 'flex-start', marginLeft: -3 }} />
        <ArabicComponent arabText={'ث) بدل السكن'} />
        <View style={{ width: '105%', height: 1, backgroundColor: '#000', marginVertical: 5, alignSelf: 'flex-start', marginLeft: -3 }} />
        <ArabicComponent arabText={'ج) بدل النقل'} />
        <View style={{ width: '105%', height: 1, backgroundColor: '#000', marginVertical: 5, alignSelf: 'flex-start', marginLeft: -3 }} />
        <ArabicComponent arabText={'ح) بدل اتصالات'} />
        <View style={{ width: '105%', height: 1, backgroundColor: '#000', marginVertical: 5, alignSelf: 'flex-start', marginLeft: -3 }} />
        <ArabicComponent arabText={'خ) بدل تذاكر طيران'} />
        <View style={{ width: '105%', height: 1, backgroundColor: '#000', marginVertical: 5, alignSelf: 'flex-start', marginLeft: -3 }} />
        <ArabicComponent arabText={'د)  وقت إضافي'} />
        <View style={{ width: '105%', height: 1, backgroundColor: '#000', marginVertical: 5, alignSelf: 'flex-start', marginLeft: -3 }} />
        <ArabicComponent arabText={'ذ) بدلات أخرى'} />
        <View style={{ width: '105%', height: 1, backgroundColor: '#000', marginVertical: 5, alignSelf: 'flex-start', marginLeft: -3 }} />
        <ArabicComponent arabText={'ر) إجمالي الراتب'} />
      </View>

      {/* col 5 */}
      <View
        style={{
          width: "12.5%",
          borderRightWidth: 1,
          padding: 2,
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Text>4</Text>
      </View>
    </View>

        <View style={{ marginTop: 30 }}>
          <View
            style={{ flexDirection: "row", width: "100%", gap: 10, border: 1 }}
          >
            <View style={{ width: "50%", borderRight: 1, padding: 5 }}>
              <Text>
                Due to any circumstances (excluding serious health issues), if
                the contract is breached by the Employee prior to the completion
                of the above-mentioned contract period, SAR 8,000/- will be the
                amount for Repatriation (Final Exit) & SAR 15,000/- will be the
                amount for Transfer the sponsorship (to other company) to be
                paid by the Employee.
              </Text>
            </View>

            <View style={{ width: "50%", padding: 5 }}>
              <ArabicComponent
                arabText={
                  "ي حال اي ظروف (باستثناء المشكلات الصحية الخطيرة)، إذا قام الموظف بخرق العقد قبل انتهاء فترة العقد المذكورة أعلاه، فسيكون المبلغ / 8000 ريال سعودي"
                }
              />
              <ArabicComponent
                arabText={
                  "وفي حال (الخروج النهائي) سيكون المبلغ 15000 ريال سعودي لنقل الكفالة لكفيل أخر ويتم دفعه من قبل الموظف ."
                }
              />
            </View>
          </View>
          <View
            style={{ flexDirection: "row", width: "100%", gap: 10, border: 1 }}
          >
            <View style={{ width: "50%", borderRight: 1, padding: 5 }}>
              <Text>
                {`I hereby agree that I have reviewed and understood all the undertaking items and contents and has no right to criticize the undertaking contents or anything else, also I have agreed that, I will abide to the work assigned by the ${companyDetails[0]?.name} and well aware of all its conditions, items and contents.`}
              </Text>
            </View>

            <View style={{ width: "50%", padding: 5 }}>
              <Text>
                <ArabicComponent
                  arabText={
                    "وافق واقر بموجب هذا أنني قمت بمراجعة وفهم جميع بنود التعهد ومحتوياته  ولا يحق لي إنتقاد محتوى هذا التعهد  أو أي شيء آخر، كما اوافق على الإلتزام بالعمل ."
                  }
                />
                <Text>{companyDetails[0]?.name_arabic}</Text>
                <ArabicComponent
                  arabText={
                    " الذي اوكله لي وانا ادرك جميع شروط التعهد وبنوده ومحتوياته ."
                  }
                />
              </Text>
            </View>
          </View>
        </View>

        <View style={{ gap: 20, marginTop: 10 }}>
          <View style={{ flexDirection: "row" }}>
            <Text>(- Signature /</Text>
            <ArabicComponent
              arabText={" التوقيع)	:	التوقيع"}
              textStyle={{ fontFamily: "ArabicBold" }}
            />
          </View>
          <View
            style={{
              justifyContent: "space-between",
              alignItems: "center",
              flexDirection: "row",
            }}
          >
            <Text style={{ textDecoration: "underline" }}>
              Thumb Impression /
            </Text>
            <ArabicComponent
              arabText={"البصمة"}
              textStyle={{
                fontFamily: "ArabicBold",
                textDecoration: "underline",
              }}
            />
          </View>
          <View
            style={{
              justifyContent: "space-between",
              alignItems: "center",
              flexDirection: "row",
            }}
          >
            <Text style={{ textDecoration: "underline" }}>
              Passport Number: {data?.passport_number}
            </Text>
            <ArabicComponent
              arabText={`${data?.passport_number} رقم الجواز`}
              textStyle={{ fontFamily: "ArabicBold" }}
            />
          </View>
          <View
            style={{
              justifyContent: "space-between",
              alignItems: "center",
              flexDirection: "row",
            }}
          >
            <Text style={{ textDecoration: "underline" }}>
              Employee Cod: {data?.candidate_id}{" "}
            </Text>
            <ArabicComponent
              arabText={`${data?.candidate_id + " "}الرقم الوظيفي`}
              textStyle={{ fontFamily: "ArabicBold" }}
            />
          </View>
        </View>
        <View
          fixed
          style={{
            borderTop: 1,
            width: "100%",
            position: "absolute",
            bottom: 99,
            right: 30,
            padding: 1,
            margin: "auto",
          }}
        ></View>
      </PageLayout>
      {/* <LastPage contractDetails={contractDetails} /> */}
    </Document>
  );
}
